import * as React from 'react';

import { FieldValidations } from '~utils/FieldValidations';

export interface IFormContextValue {
    fieldsValidations: Record<string, FieldValidations>;
    formName?: string;
    readonlyFields: Set<string>;
    highlightedFields: Set<string>;
    removeHighlight(fieldName: string): void;
}

export const FormContext = React.createContext<IFormContextValue>({
    fieldsValidations: {},
    readonlyFields: new Set(),
    highlightedFields: new Set(),
    removeHighlight: () => {}
});
